import cn from 'classnames';
import { noOp } from 'common/Constants';
import React from 'react';
import { Clickable } from 'src/shared/design-system/Utilities';
import { Icon } from 'web-common/src/shared/design-system/components/Icon';

export interface MiniBannerProps {
  className?: string;
  bgColorClassName: string;
  mainText: string;
  supportingText?: string;
  ctaText: string;
  ctaTo?: string;
  ctaClick: () => void;
  graphic: React.ReactNode;
  smallerMainText?: boolean;
}

const sharedButtonLinkStyles = 'mr-2 text-sm font-semibold';

export const MiniBanner: React.FC<MiniBannerProps> = ({
  className,
  bgColorClassName,
  mainText,
  supportingText,
  ctaText,
  ctaTo,
  ctaClick = noOp,
  graphic,
  smallerMainText = false,
}) => (
  <Clickable
    className={cn(['flex', 'hover:text-neutral-700', 'focus:text-neutral-700', 'p-0'], className)}
    to={ctaTo}
    onClick={ctaClick}>
    <div
      className={cn(
        [
          'h-[114px]',
          'w-[296px]',
          'sm:h-[136px]',
          'sm:w-[334px]',
          'flex',
          'relative',
          'items-center',
          'overflow-hidden',
          'rounded-lg',
          'px-4',
        ],
        bgColorClassName,
        className
      )}>
      <div className='flex w-48 flex-col text-left'>
        {supportingText && <p className='m-0 mb-2 font-bold text-neutral-700'>{supportingText}</p>}
        <h3 className={`m-0 mb-2 font-bold ${smallerMainText ? 'text-base sm:text-lg ' : 'text-xl'}`}>{mainText}</h3>
        <div className='flex items-center '>
          <div className={cn(sharedButtonLinkStyles, 'border-none', 'bg-transparent p-0')}>{ctaText}</div>
          <Icon name='chevronRight' size={8} />
        </div>
      </div>
      <div className='absolute bottom-0 right-0'>{graphic}</div>
    </div>
  </Clickable>
);
